(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ovreya-slider-principal"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ovreya-slider')) {
    class OvreyaSlider extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.slides = Array.from(this.querySelectorAll('[data-ovreya-slide]'));
        if (!this.slides.length) return;

        this.initialized = true;
        this.currentIndex = 0;
        this.timer = null;
        this.touchStartX = 0;
        this.touchStartY = 0;
        this.editorPaused = false;
        this.autoplayEnabled = this.dataset.autoplay === 'true';
        this.pauseOnHover = this.dataset.pauseHover === 'true';
        this.delay = Math.max(2500, Number(this.dataset.delay) || 5000);
        this.dots = Array.from(this.querySelectorAll('[data-ovreya-dot]'));
        this.previousButton = this.querySelector('[data-ovreya-previous]');
        this.nextButton = this.querySelector('[data-ovreya-next]');

        this.handlePrevious = () => this.showSlide(this.currentIndex - 1);
        this.handleNext = () => this.showSlide(this.currentIndex + 1);
        this.handleKeydown = (event) => {
          if (event.key === 'ArrowLeft') this.showSlide(this.currentIndex - 1);
          if (event.key === 'ArrowRight') this.showSlide(this.currentIndex + 1);
        };
        this.handleTouchStart = (event) => {
          const touch = event.changedTouches[0];
          this.touchStartX = touch.clientX;
          this.touchStartY = touch.clientY;
          this.stopAutoplay();
        };
        this.handleTouchEnd = (event) => {
          const touch = event.changedTouches[0];
          const distanceX = touch.clientX - this.touchStartX;
          const distanceY = touch.clientY - this.touchStartY;

          if (Math.abs(distanceX) > 45 && Math.abs(distanceX) > Math.abs(distanceY)) {
            this.showSlide(this.currentIndex + (distanceX < 0 ? 1 : -1));
          } else {
            this.startAutoplay();
          }
        };
        this.handleVisibility = () => {
          if (document.hidden) this.stopAutoplay();
          else this.startAutoplay();
        };
        this.handleBlockSelect = (event) => {
          const selectedSlide = event.target.closest('[data-ovreya-slide]');
          if (!selectedSlide || !this.contains(selectedSlide)) return;

          this.editorPaused = true;
          this.stopAutoplay();
          this.showSlide(Number(selectedSlide.dataset.slideIndex), false);
        };
        this.handleBlockDeselect = (event) => {
          const selectedSlide = event.target.closest('[data-ovreya-slide]');
          if (!selectedSlide || !this.contains(selectedSlide)) return;

          this.editorPaused = false;
          this.startAutoplay();
        };
        this.handleMouseEnter = () => this.stopAutoplay();
        this.handleMouseLeave = () => this.startAutoplay();
        this.handleFocusIn = () => this.stopAutoplay();
        this.handleFocusOut = () => this.startAutoplay();

        this.previousButton?.addEventListener('click', this.handlePrevious);
        this.nextButton?.addEventListener('click', this.handleNext);
        this.addEventListener('keydown', this.handleKeydown);
        this.addEventListener('touchstart', this.handleTouchStart, { passive: true });
        this.addEventListener('touchend', this.handleTouchEnd, { passive: true });
        document.addEventListener('visibilitychange', this.handleVisibility);
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
        document.addEventListener('shopify:block:deselect', this.handleBlockDeselect);

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.showSlide(Number(dot.dataset.ovreyaDot)));
        });

        if (this.pauseOnHover) {
          this.addEventListener('mouseenter', this.handleMouseEnter);
          this.addEventListener('mouseleave', this.handleMouseLeave);
          this.addEventListener('focusin', this.handleFocusIn);
          this.addEventListener('focusout', this.handleFocusOut);
        }

        this.showSlide(0, false);
        this.startAutoplay();
      }

      disconnectedCallback() {
        if (!this.initialized) return;

        this.stopAutoplay();
        this.previousButton?.removeEventListener('click', this.handlePrevious);
        this.nextButton?.removeEventListener('click', this.handleNext);
        this.removeEventListener('keydown', this.handleKeydown);
        this.removeEventListener('touchstart', this.handleTouchStart);
        this.removeEventListener('touchend', this.handleTouchEnd);
        this.removeEventListener('mouseenter', this.handleMouseEnter);
        this.removeEventListener('mouseleave', this.handleMouseLeave);
        this.removeEventListener('focusin', this.handleFocusIn);
        this.removeEventListener('focusout', this.handleFocusOut);
        document.removeEventListener('visibilitychange', this.handleVisibility);
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.handleBlockDeselect);
        this.initialized = false;
      }

      showSlide(requestedIndex, restartAutoplay = true) {
        this.currentIndex = (requestedIndex + this.slides.length) % this.slides.length;

        this.slides.forEach((slide, index) => {
          const isActive = index === this.currentIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', String(!isActive));
        });

        this.dots.forEach((dot, index) => {
          const isActive = index === this.currentIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', String(isActive));
        });

        if (restartAutoplay) this.startAutoplay();
      }

      stopAutoplay() {
        window.clearTimeout(this.timer);
        this.timer = null;
      }

      startAutoplay() {
        this.stopAutoplay();

        if (!this.autoplayEnabled || this.editorPaused || this.slides.length < 2 || document.hidden) return;

        this.timer = window.setTimeout(() => {
          this.showSlide(this.currentIndex + 1, false);
          this.startAutoplay();
        }, this.delay);
      }
    }

    customElements.define('ovreya-slider', OvreyaSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
